import { render } from "./BaseSpinner2.vue?vue&type=template&id=616b1ed6"
import script from "./BaseSpinner2.vue?vue&type=script&lang=js"
export * from "./BaseSpinner2.vue?vue&type=script&lang=js"

import "./BaseSpinner2.vue?vue&type=style&index=0&id=616b1ed6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__